import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';
import { refreshSessionForRetry } from './fetchWithSession';

/** Keep multipart/progress handling and raw HTTP errors; replay only a rejected credential once. */
export async function postWithSession<T>(
  url: string,
  body: FormData,
  config: AxiosRequestConfig,
): Promise<AxiosResponse<T>> {
  const accessToken = sessionStorage.getItem('access_token');
  const refreshToken = sessionStorage.getItem('refresh_token');
  const sessionId = sessionStorage.getItem('auth_session_id');
  try {
    return await axios.post<T>(url, body, config);
  } catch (error: unknown) {
    if ((error as { response?: { status?: number } } | undefined)?.response?.status !== 401 || config.signal?.aborted) throw error;
    const nextToken = await refreshSessionForRetry(accessToken, refreshToken, undefined, sessionId);
    if (!nextToken || config.signal?.aborted) throw error;
    return axios.post<T>(url, body, {
      ...config,
      headers: { ...config.headers, Authorization: `Bearer ${nextToken}` },
    });
  }
}
